export default __webpack_public_path__ + "50d142741dbdf9c6f21d181d1831e978.png";